export default {
  "recruit-ai": {
    "first": {
      "visual": "se.jpg",
      "job": "人工知能（IBM Watson）開発エンジニア",
      "catch": "人工知能の活用でビジネスシーンを変化させる",
      "read": "IBM Cloud / Watson API を利用した設計・開発を通して、お客様それぞれに合ったソリューションを提供します。"
    },
    "new": {
      "status": "正社員",
      "job": "人工知能（IBM Watson）開発エンジニア",
      "work": "人工知能を活用したソリューション、システムの設計・開発。<br />主に IBM Cloud / Watson API を利用したソリューションの設計・開発を行っていただきます。<br />弊社内プロジェクトチームへの参画を予定しております。",
      "qualification": "IT未経験者・経験者とも歓迎<br />学歴不問<br />第二新卒歓迎<br />システム設計・実装の経験者、データベース設計・運用の経験者、統計分析業務の経験者優遇します。<br />人工知能はIBM Cloud / Watson APIの利用が主であり、人工知能そのものの開発以外にも業務が発生することをご了承ください。",
      "location": "本社または客先常駐<br /><br />本社<br />〒106-0032<br />東京都港区六本木4-1-4 黒崎ビル8階<br />東京メトロ南北線六本木一丁目駅　徒歩5分<br />東京メトロ千代田線　赤坂駅　徒歩15分<br /><br />原則として東京ですが、お客様の所在地により<br />神奈川県、千葉県、埼玉県などとなる可能性もあります。",
      "time": "標準勤務時間帯　9:00～17:30(標準労働時間　1日　7時間30分)<br />1週37時間30分",
      "holiday": "完全週休2日制(土、日)、国民の祝日、年末年始(12月30日～1月3日)<br />創立記念日(9月17日) 、有給休暇(初年度10日) 、慶弔特別有給休暇",
      "salary": "月給25万～50万(スキルに応じて決定)",
      "allowances": "昇給　年1回(4月)<br />賞与　会社及び個人の業績を考慮し、その都度決定",
      "benefit": "通勤手当(全額)、資格取得奨励金、報奨金、扶養手当",
      "welfare": "保険、厚生年金、健康保険、雇用保険、労災保険<br />契約保養レクリエーション施設利用可能　等",
      "healthcare": "定期健康診断、健康相談　等",
      "education": "技術修得、マイクロソフト社・SAP社・Oracle社等の社外研修、公的資格取得支援 等"
    }
  },
  "recruit-bpo": {
    "first": {
      "visual": "bpo.jpg",
      "job": "一般職　事務スタッフ<br />総合職　事務スタッフ",
      "catch": "ビジネスプロセスアウトソーシング",
      "read": "業務オペレーションとITスキル、改善提案を組み合わせたSOLPAC独自のBPOを展開しております。"
    },
    "new": {
      "status": "正社員　プロジェクト契約社員　プロジェクト限定契約社員",
      "job": "一般職　事務スタッフ<br />総合職　事務スタッフ（サブリーダー、リーダ候補）",
      "work": "<span>外資系企業のバックオフィス業務</span><br />お客様により異なります。業務詳細はお問い合わせください。<br />・データ作成（マーケティングデータ）の作成、データチェック、レポート作成。<br />・コール業務（修理受付、Web画面の使用説明、マーケティング調査に関する説明）<br />※受電業務が中心ですが、発信業務も稀に発生します。<br />顧客データ管理（Excel　Access、の他　システムオペレーションも伴います。）<br />見積、受注、購買業務（一連の営業、サービス業務のサポート）<br />ロジスティックス関連業務（在庫、発注、物品の移動管理）<br />随時募集しています。お気軽にお問い合わせください。",
      "qualification": "未経験歓迎<br />事務経験者は優遇します<br />第二新卒歓迎",
      "location": "新宿（徒歩3分）、品川（徒歩8分）、保土ヶ谷（徒歩15分／無料バス有）、新横浜（徒歩10分）等",
      "time": "基本　9時～17時30分",
      "holiday": "完全週休2日制(土、日)、国民の祝日、年末年始(12月30日～1月3日)<br />創立記念日(9月17日) 、有給休暇(初年度10日) 、慶弔特別有給休暇",
      "salary": "≪月給≫異業種転換者：23万円～、事務経験者：25万円～<br />リーダークラスの方は別途考慮",
      "allowances": "昇給　年1回(4月)<br />賞与　会社及び個人の業績を考慮し、その都度決定",
      "benefit": "通勤手当(全額)、資格取得奨励金、報奨金、扶養手当",
      "welfare": "保険、厚生年金、健康保険、雇用保険、労災保険<br />契約保養レクリエーション施設利用可能　等",
      "healthcare": "定期健康診断、健康相談　等",
      "education": "技術修得、マイクロソフト社・SAP社・Oracle社等の社外研修、公的資格取得支援 等"
    }
  },
  "recruit-programmer": {
    "first": {
      "visual": "programer.jpg",
      "job": "IBM i（AS/400）開発エンジニア",
      "catch": "創立当初からソルパックの柱となるIBM i業務",
      "read": "開発・改修経験豊富なソルパックのエンジニアと共に、IBM iに必要なサービスをワンストップでお客様にご提供していただきます。"
    },
    "new": {
      "status": "正社員",
      "job": "IBM i（AS/400）開発エンジニア",
      "work": "新規または追加の開発・改修（RPG、CL、SQLなど）にともなう要件定義、設計、構築、テスト、リリース作業、運用まで一通りを1人称で実施いただきます。<br />また、上記に関わるプロジェクト管理経験、リームリーダー（5名ほど）等もお任せいたします。",
      "qualification": "IT未経験者・経験者とも歓迎<br />学歴不問<br />第二新卒歓迎",
      "location": "本社または客先常駐<br /><br />本社<br />〒106-0032<br />東京都港区六本木4-1-4 黒崎ビル8階<br />東京メトロ南北線六本木一丁目駅　徒歩5分<br />東京メトロ千代田線　赤坂駅　徒歩15分<br /><br />原則として東京ですが、お客様の所在地により<br />神奈川県、千葉県、埼玉県などとなる可能性もあります。",
      "time": "標準勤務時間帯　9:00～17:30(標準労働時間　1日　7時間30分)<br />1週37時間30分",
      "holiday": "完全週休2日制(土、日)、国民の祝日、年末年始(12月30日～1月3日)<br />創立記念日(9月17日) 、有給休暇(初年度10日) 、慶弔特別有給休暇",
      "salary": "月給25万～(スキルに応じて決定)",
      "allowances": "昇給　年1回(4月)<br />賞与　会社及び個人の業績を考慮し、その都度決定",
      "benefit": "通勤手当(全額)、資格取得奨励金、報奨金、扶養手当",
      "welfare": "保険、厚生年金、健康保険、雇用保険、労災保険<br />契約保養レクリエーション施設利用可能　等",
      "healthcare": "定期健康診断、健康相談　等",
      "education": "技術修得、マイクロソフト社・SAP社・Oracle社等の社外研修、公的資格取得支援 等"
    }
  },
  "recruit-sap": {
    "first": {
      "visual": "sap.jpg",
      "job": "SAP B-oneエンジニア",
      "catch": "国内トップクラスの実績を誇るソルパックのSAP B-One業務",
      "read": "中小企業向けERP「SAP Business one」に関する業務全般、プロジェクト管理を行っていただきます。"
    },
    "new": {
      "status": "正社員",
      "job": "SAP B-oneエンジニア",
      "work": "財務会計、販売管理、購買管理、在庫管理、債権債務管理、輸出入などの幅広い業務のお客様のSAP Business oneシステムに対し、コンサル、プロジェクト計画、要件定義、設計、開発、製品設定、テスト、運用、移行などの業務をお任せいたします。<br />また、上記に関わるプロジェクト管理経験、リームリーダー（5名ほど）等もお任せいたします。",
      "qualification": "NavisionやOBICなどのパッケージ導入コンサル経験がある。<br />SAPなど大規模システムで特定モジュールに特化しているよりも、小規模システム導入のコンサル経験がある方がよい。<br />必要によっては、単独でユーザとの要件定義に臨める。<br />SQLの知識を有する。",
      "location": "本社または客先常駐<br /><br />本社<br />〒106-0032<br />東京都港区六本木4-1-4 黒崎ビル8階<br />東京メトロ南北線六本木一丁目駅　徒歩5分<br />東京メトロ千代田線　赤坂駅　徒歩15分<br /><br />原則として東京ですが、お客様の所在地により<br />神奈川県、千葉県、埼玉県などとなる可能性もあります。",
      "time": "標準勤務時間帯　9:00～17:30(標準労働時間　1日　7時間30分)<br />1週37時間30分",
      "holiday": "完全週休2日制(土、日)、国民の祝日、年末年始(12月30日～1月3日)<br />創立記念日(9月17日) 、有給休暇(初年度10日) 、慶弔特別有給休暇",
      "salary": "月給25万～(スキルに応じて決定)",
      "allowances": "昇給　年1回(4月)<br />賞与　会社及び個人の業績を考慮し、その都度決定",
      "benefit": "通勤手当(全額)、資格取得奨励金、報奨金、扶養手当",
      "welfare": "保険、厚生年金、健康保険、雇用保険、労災保険<br />契約保養レクリエーション施設利用可能　等",
      "healthcare": "定期健康診断、健康相談　等",
      "education": "技術修得、マイクロソフト社・SAP社・Oracle社等の社外研修、公的資格取得支援 等"
    }
  },
  "recruit-mw": {
    "first": {
      "visual": "mw.jpg",
      "job": "設備管理MW（IBM Maximo）エンジニア",
      "catch": "設備管理システムの設計・構築業務",
      "read": "設備管理やサービスデスクを実現するMaximoの設計・構築業務全般を行っていただきます。"
    },
    "new": {
      "status": "正社員",
      "job": "設備管理MW（IBM Maximo）エンジニア",
      "work": "設備管理システムの設計・構築<br />設備管理MW（IBM Maximo）を使用したシステム設計・構築を行っていただきます。<br />弊社経験者リーダーの元、チームメンバーとしての参画からを予定しています。",
      "qualification": "IT未経験者・経験者とも歓迎<br />学歴不問<br />第二新卒歓迎<br />設備管理業務、MW開発に関する経験のある方は優遇します",
      "location": "本社または客先常駐<br /><br />本社<br />〒106-0032<br />東京都港区六本木4-1-4 黒崎ビル8階<br />東京メトロ南北線六本木一丁目駅　徒歩5分<br />東京メトロ千代田線　赤坂駅　徒歩15分<br /><br />原則として東京ですが、お客様の所在地により<br />神奈川県、千葉県、埼玉県などとなる可能性もあります。",
      "time": "標準勤務時間帯　9:00～17:30(標準労働時間　1日　7時間30分)<br />1週37時間30分",
      "holiday": "完全週休2日制(土、日)、国民の祝日、年末年始(12月30日～1月3日)<br />創立記念日(9月17日) 、有給休暇(初年度10日) 、慶弔特別有給休暇",
      "salary": "月給25万～50万(スキルに応じて決定)",
      "allowances": "昇給　年1回(4月)<br />賞与　会社及び個人の業績を考慮し、その都度決定",
      "benefit": "通勤手当(全額)、資格取得奨励金、報奨金、扶養手当",
      "welfare": "保険、厚生年金、健康保険、雇用保険、労災保険<br />契約保養レクリエーション施設利用可能　等",
      "healthcare": "定期健康診断、健康相談　等",
      "education": "技術修得、マイクロソフト社・SAP社・Oracle社等の社外研修、公的資格取得支援 等<br />Maximo開発技術の研修コンテンツあり"
    }
  },
  "recruit-infra": {
    "first": {
      "visual": "infra.jpg",
      "job": "IBM i（AS/400）インフラエンジニア",
      "catch": "確かなインフラ技術力を駆使したIBM i サポート",
      "read": "コストパフォーマンスに優れ、システム基盤としての品質を担保したインフラ構築ができる人材を募集しています。"
    },
    "new": {
      "status": "正社員",
      "job": "IBM i（AS/400）インフラエンジニア",
      "work": "新規またはリプレースにともなうIBM i サーバーのインフラ設計・構築、OS・M/W設定などを1人称で実施いただきます。また、上記に関わるプロジェクト管理、チームリーダー(5名ほど)、等をお任せいたします。",
      "qualification": "IT未経験者・経験者とも歓迎<br />学歴不問<br />第二新卒歓迎",
      "location": "本社または客先常駐<br /><br />本社<br />〒106-0032<br />東京都港区六本木4-1-4 黒崎ビル8階<br />東京メトロ南北線六本木一丁目駅　徒歩5分<br />東京メトロ千代田線　赤坂駅　徒歩15分<br /><br />原則として東京ですが、お客様の所在地により<br />神奈川県、千葉県、埼玉県などとなる可能性もあります。",
      "time": "標準勤務時間帯　9:00～17:30(標準労働時間　1日　7時間30分)<br />1週37時間30分",
      "holiday": "完全週休2日制(土、日)、国民の祝日、年末年始(12月30日～1月3日)<br />創立記念日(9月17日) 、有給休暇(初年度10日) 、慶弔特別有給休暇",
      "salary": "月給25万～(スキルに応じて決定)",
      "allowances": "昇給　年1回(4月)<br />賞与　会社及び個人の業績を考慮し、その都度決定",
      "benefit": "通勤手当(全額)、資格取得奨励金、報奨金、扶養手当",
      "welfare": "保険、厚生年金、健康保険、雇用保険、労災保険<br />契約保養レクリエーション施設利用可能　等",
      "healthcare": "定期健康診断、健康相談　等",
      "education": "技術修得、マイクロソフト社・SAP社・Oracle社等の社外研修、公的資格取得支援 等"
    }
  },
  "recruit-pm": {
    "first": {
      "visual": "pm.jpg",
      "job": "PCキッティングプロジェクトマネージャー",
      "catch": "LCMサービスのマネジメント業務",
      "read": "プロジェクト管理、倉庫管理、人事管理などマネジメント経験を生かして働いていただきます。"
    },
    "new": {
      "status": "正社員",
      "job": "PCキッティングプロジェクトマネージャー",
      "work": "IT機器LCMサービス提供に於ける管理業務全般",
      "qualification": "プロジェクト管理/倉庫管理/人事管理を5年以上経験のある方<br />MCP（Windows）/ 倉庫管理主任者をお持ちの方<br />ロジスティクス経験がある方は優遇します",
      "location": "本社<br />〒106 - 0032<br />東京都港区六本木4 - 1 - 4 黒崎ビル8階<br />東京メトロ南北線六本木一丁目駅　徒歩5分<br />東京メトロ千代田線　赤坂駅　徒歩15分<br /><br />原則として東京ですが、お客様の所在地により<br />神奈川県、千葉県、埼玉県などとなる可能性もあります。",
      "time": "標準勤務時間帯　9:00～17:30(標準労働時間　1日　7時間30分)<br />1週37時間30分",
      "holiday": "完全週休2日制(土、日)、国民の祝日、年末年始(12月30日～1月3日)<br />創立記念日(9月17日) 、有給休暇(初年度10日) 、慶弔特別有給休暇",
      "salary": "月給25万～50万(スキルに応じて決定)",
      "allowances": "昇給　年1回(4月)<br />賞与　会社及び個人の業績を考慮し、その都度決定",
      "benefit": "通勤手当(全額)、資格取得奨励金、報奨金、扶養手当",
      "welfare": "保険、厚生年金、健康保険、雇用保険、労災保険<br />契約保養レクリエーション施設利用可能　等",
      "healthcare": "定期健康診断、健康相談　等",
      "education": "技術修得、マイクロソフト社・SAP社・Oracle社等の社外研修、公的資格取得支援 等"
    }
  },
  "recruit-pk": {
    "first": {
      "visual": "pk.jpg",
      "job": "PCキッティングリーダー",
      "catch": "社内環境を整備できる頼れるサポーターに",
      "read": "必要なアプリケーションのインストールや、社内ネットワークを整備し、作業を円滑に行うサポートを行っていただきます。"
    },
    "new": {
      "status": "正社員",
      "job": "PCキッティングリーダー",
      "work": "IT機器LCMサービス提供に於ける管理業務全般",
      "qualification": "PCキッティング経験2年以上",
      "location": "本社<br />〒106 - 0032<br />東京都港区六本木4 - 1 - 4 黒崎ビル8階<br />東京メトロ南北線六本木一丁目駅　徒歩5分<br />東京メトロ千代田線　赤坂駅　徒歩15分<br /><br />原則として東京ですが、お客様の所在地により<br />神奈川県、千葉県、埼玉県などとなる可能性もあります。",
      "time": "標準勤務時間帯　9:00～17:30(標準労働時間　1日　7時間30分)<br />1週37時間30分",
      "holiday": "完全週休2日制(土、日)、国民の祝日、年末年始(12月30日～1月3日)<br />創立記念日(9月17日) 、有給休暇(初年度10日) 、慶弔特別有給休暇",
      "salary": "月給25万～50万(スキルに応じて決定)",
      "allowances": "昇給　年1回(4月)<br />賞与　会社及び個人の業績を考慮し、その都度決定",
      "benefit": "通勤手当(全額)、資格取得奨励金、報奨金、扶養手当",
      "welfare": "保険、厚生年金、健康保険、雇用保険、労災保険<br />契約保養レクリエーション施設利用可能　等",
      "healthcare": "定期健康診断、健康相談　等",
      "education": "技術修得、マイクロソフト社・SAP社・Oracle社等の社外研修、公的資格取得支援 等"
    }
  },
  "recruit-windows": {
    "first": {
      "visual": "windows.jpg",
      "job": "Windows10 Upgrade及び<br />資産管理プロジェクト メンバー",
      "catch": "Windows10 Upgradeのチェック、及び資産状況の確認等PCに関するプロジェクト",
      "read": "既卒・第二新卒歓迎。PCに関するプロジェクトのメンバーを募集しています。"
    },
    "new": {
      "status": "正社員",
      "job": "Windows10 Upgrade及び資産管理プロジェクト メンバー",
      "work": "PCのWindows10 Upgradeのチェック、及び資産状況の確認等PCに関するプロジェクト",
      "qualification": "PCキッティング経験があれば尚可<br />IT未経験者はPCが好きな事（既卒、第二新卒歓迎）",
      "location": "弊社の客先常駐　神奈川県藤沢市<br />※詳細はメールまたは面談時に説明",
      "time": "標準勤務時間帯　9:00～17:30(標準労働時間1日7時間30分)<br />1週37時間30分",
      "holiday": "完全週休2日制(土、日)、国民の祝日、年末年始(12月30日～1月3日)<br />創立記念日(9月17日) 、有給休暇(初年度10日) 、慶弔特別有給休暇",
      "salary": "月給25万～(スキルに応じて決定)<br />未経験者：面談時に説明",
      "allowances": "昇給　年1回(4月)<br />賞与　会社及び個人の業績を考慮し、その都度決定",
      "benefit": "通勤手当(全額)、資格取得奨励金、報奨金、扶養手当",
      "welfare": "保険、厚生年金、健康保険、雇用保険、労災保険<br />契約保養レクリエーション施設利用可能　等",
      "healthcare": "定期健康診断、健康相談　等",
      "education": "技術修得、マイクロソフト社・SAP社・Oracle社等の社外研修、公的資格取得支援 等"
    }
  }
}


// WEBPACK FOOTER //
// ./src/json/recruitments.js